import { ReactElement } from "react";
import { Link } from "react-router-dom";

import { Box, Typography } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

const sxStyles = {
    root: {
        backgroundColor: "#fff",
        height: "100%",
        padding: "16px 20px",
        cursor: "pointer",
        borderRadius: "8px",
        boxShadow: "0px 4px 25px 0px #0000000D",
        textDecoration: "none",

        "&:hover": {
            backgroundColor: "#BFCEE3",
        },
    },
    disabled: {
        color: "#8D8D8D",
        cursor: "default",

        "& .MuiSvgIcon-root": {
            color: "#8D8D8D",
        },
        "&:hover": {
            backgroundColor: "#fff",
        },
    },
    container: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "30px",

        "@media (max-width: 850px)": {
            display: "flex",
            gap: "20px",
            overflow: "auto",
            scrollSnapType: "x mandatory",

            "::-webkit-scrollbar": { display: "none" },

            "& > *": {
                scrollSnapAlign: "center",
                minWidth: "90%",
            },
        },
    },
    title: {
        fontSize: "14px",
        fontWeight: "500",
        marginBottom: "0",
        color: "#1F3045",

        "@media (max-width: 850px)": {
            fontSize: "13px",
        },
    },
    description: {
        fontSize: "14px",
        fontWeight: "400",
        color: "#5A6B81",
    },
    iconRoot: {
        display: "inline-flex",

        "& .MuiSvgIcon-root": {
            width: "2rem",
            height: "2rem",
        },
    },
    titleTop: {
        marginTop: "12px",
    },
};

interface Props {
    data: ({
        url: string;
        tileTitle: ReactElement;
        tileIcon: ReactElement;
        tileText: ReactElement;
        sortOrder: number;
    } | null)[];
    sx?: {
        root?: SystemStyleObject;
        icon?: SystemStyleObject;
        container?: SystemStyleObject;
        title?: SystemStyleObject;
    };
}

const Carousel = ({ data, sx }: Props) => {
    return (
        <Box sx={[sxStyles.container, { ...sx?.container }]}>
            {data.map((value, index) => {
                const userHasAccess = value?.url !== "#";

                return (
                    <Box
                        key={index}
                        sx={[sxStyles.root, { ...sx?.root }, !userHasAccess && sxStyles.disabled]}
                        component={Link}
                        to={userHasAccess && value?.url ? value.url : "#"}
                    >
                        <Box sx={[sxStyles.iconRoot, { ...sx?.icon }, !userHasAccess && sxStyles.disabled]}>
                            {value?.tileIcon}
                        </Box>

                        <Typography
                            variant="h6"
                            sx={[
                                sxStyles.title,
                                sxStyles.titleTop,
                                { ...sx?.title },
                                !userHasAccess && sxStyles.disabled,
                            ]}
                        >
                            {value?.tileTitle}
                        </Typography>

                        <Typography sx={[sxStyles.description, !userHasAccess && sxStyles.disabled]}>
                            {value?.tileText}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default Carousel;
